import { MutableRefObject, useRef } from 'react';

import { PaymentServiceTypes } from '../../services/PaymentServices/APIService';
import PaymentServices from '../../services/PaymentServices/APIService/index.api';
import { networkCallWithApisauceWithHeaders } from '../../utils/AuthAPIUtils';

import { usePaymentsRefreshAuthTokens } from '../usePaymentsRefreshAuthTokens';

const usePaymentServices = () => {
  const { refreshTokenApi, getRefreshToken, getAccessToken } =
    usePaymentsRefreshAuthTokens();
  const paymentRef: MutableRefObject<PaymentServiceTypes | null> = useRef(null);

  if (paymentRef.current === null) {
    paymentRef.current = new PaymentServices(
      networkCallWithApisauceWithHeaders({
        refreshAuthTokensAPI: refreshTokenApi,
        getAccessToken: getAccessToken,
        getRefreshToken: getRefreshToken
      })
    );
  }
  return { paymentServices: paymentRef.current };
};

export default usePaymentServices;
